// extracted by mini-css-extract-plugin
module.exports = {"UserInterests__list":"UserInterests_UserInterests__list__CMiI8","UserInterests__tag":"UserInterests_UserInterests__tag__20ctu"};